import { FC, useLayoutEffect, useRef } from 'react'
import styles from './css/PromoCsMoney.module.css'
import { useTypedSelector } from '../hooks/useTypedSelector'

const PromoCsMoney: FC = () => {
	const ref = useRef<HTMLDivElement>(null)

	useLayoutEffect(() => {
		ref.current.style.setProperty('padding', '0', 'important')
	}, [])

	const { current: currLang } = useTypedSelector(x => x.lang)

	const url = 'https://cs.money/market/sell/?utm_source=mediabuy&utm_medium=vvtable&utm_campaign=is_cashout&utm_content=banner'
	const bannerPath = '/Resources/promo/csmoney/19102026'
	const alt = currLang === 0 ? 'CS.MONEY — мгновенная продажа скинов' : 'CS.MONEY — sell skins instantly'
	return (
		<div className={styles.container} ref={ref}>
			<a href={url} target='_blank' rel='nofollow sponsored noopener noreferrer'>
				<picture>
					<source media='(min-width: 2560px), (max-width: 600px)' srcSet={`${bannerPath}/banner-2560x50.png`} />
					<img src={`${bannerPath}/banner-1915x32.png`} width={1915} height={32} alt={alt} />
				</picture>
			</a>
		</div>
	)
}

export default PromoCsMoney
